import { GLOBAL } from 'saddlebag-browser';
import { SingleValueCookie } from 'saddlebag-cookie';
import { isNonEssentialTrackingEnabled } from 'saddlebag-tracking-preferences';

const $window = GLOBAL.getWindow();

const isLocalhost = () =>
  ['localhost', '127.0.0.1', ''].includes($window.location.hostname);

const CASH_BACK_USER_ID = 'cbuserid';
const EXPIRES_DAYS = 1;

const storeCashBackUserId = (cashBackUserId: any, market?: string) => {
  if (!cashBackUserId || cashBackUserId === 'undefined') {
    return;
  }
  if (!market) {
    return;
  }
  if (!isNonEssentialTrackingEnabled(market)) {
    return;
  }
  const cookie = new SingleValueCookie(CASH_BACK_USER_ID);
  cookie.setValue(cashBackUserId);
  if (isLocalhost()) {
    cookie.store(EXPIRES_DAYS, { secure: false, path: '/' }); // NOSONAR
  } else {
    cookie.store(EXPIRES_DAYS);
  }
};

const getCashBackUserId = () =>
  new SingleValueCookie(CASH_BACK_USER_ID).getValue();

export { getCashBackUserId, storeCashBackUserId };
